// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__phIt9","card":"ErrorBoundary_card__1-8J3","title":"ErrorBoundary_title__ncImb","message":"ErrorBoundary_message__98g5v"};